/* Reese theme — rails, colour layers, drawer */
(function () {
  'use strict';
  function $$ (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---- horizontal rails with arrows ---- */
  function initRail(wrap) {
    var rail = wrap.querySelector('.r-rail');
    if (!rail || rail.classList.contains('r-rail--grid')) return;
    var prev = wrap.querySelector('[data-rail-prev]');
    var next = wrap.querySelector('[data-rail-next]');
    function step(dir) {
      var card = rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width : 400;
      rail.scrollBy({ left: dir * card, behavior: 'smooth' });
    }
    function update() {
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---- product card colour dots ---- */
  function initCard(card) {
    var imgs = $$('.r-card__img[data-layer]', card);
    var hover = card.querySelector('.r-card__img--hover');
    $$('.r-dot[data-layer]', card).forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var layer = dot.getAttribute('data-layer');
        imgs.forEach(function (img) {
          var on = img.getAttribute('data-layer') === layer;
          img.classList.toggle('is-active', on);
          if (on && img.dataset.src && !img.src) { img.src = img.dataset.src; }
          if (on && img.getAttribute('loading') === 'lazy') img.removeAttribute('loading');
        });
        if (hover) hover.classList.toggle('is-hover', layer === '0');
        $$('.r-dot', card).forEach(function (d) { d.classList.toggle('is-active', d === dot); });
        var link = card.querySelector('a.r-card__link');
        if (link && dot.dataset.url) link.href = dot.dataset.url;
      });
    });
  }

  /* ---- menu drawer ---- */
  function initDrawer() {
    var drawer = document.getElementById('ReeseDrawer');
    if (!drawer) return;
    var scrim = document.getElementById('ReeseScrim');
    var openers = $$('[data-reese-open-menu]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open'); if (scrim) scrim.classList.add('is-open');
      document.body.classList.add('r-lock');
      drawer.setAttribute('aria-hidden', 'false');
      var first = drawer.querySelector('input, a, button');
      if (first) setTimeout(function () { first.focus(); }, 50);
    }
    function close() {
      drawer.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-open');
      document.body.classList.remove('r-lock');
      drawer.setAttribute('aria-hidden', 'true');
      if (lastFocus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    $$('[data-reese-close-menu]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var focusSearch = $$('[data-reese-open-search]');
    focusSearch.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); open();
        var inp = drawer.querySelector('input[type="search"]');
        if (inp) setTimeout(function () { inp.focus(); }, 120);
      });
    });
  }

  function init(root) {
    $$('[data-reese-rail]', root).forEach(initRail);
    $$('.r-card', root).forEach(initCard);
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); initDrawer(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initDrawer(); });
})();
